import { render, staticRenderFns } from "./product-row.vue?vue&type=template&id=31fd0113&"
import script from "./product-row.vue?vue&type=script&lang=js&"
export * from "./product-row.vue?vue&type=script&lang=js&"
import style0 from "./product-row.vue?vue&type=style&index=0&id=31fd0113&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports